var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Dialog } from '@material-ui/core';
import styled from 'styled-components';
export var LoaderDialog = styled(function (props) { return (React.createElement(Dialog, __assign({}, props, { classes: { paper: 'LoaderDialog-paper' } }))); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .LoaderDialog-paper {\n    background-color: ", ";\n    color: ", ";\n    font-size: ", "px;\n    padding: ", "px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"], ["\n  .LoaderDialog-paper {\n    background-color: ", ";\n    color: ", ";\n    font-size: ", "px;\n    padding: ", "px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"])), function (props) { return props.theme.backgroundColor || 'rgba(0, 0, 0, 0.7)'; }, function (props) { return props.theme.textColor || 'white'; }, function (props) { return props.theme.fontSize || 20; }, function (props) { return props.theme.onlyText ? 20 : 34; });
export var CircularProgressStyling = function (loaderSize, color) { return ({
    color: "" + (color || 'white'),
    width: (loaderSize || 40) + "px",
    height: (loaderSize || 40) + "px",
    'justify-content': 'flex-end',
    'align-items': 'flex-end',
    margin: 'auto'
}); };
export var LoaderText = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: ", ";\n"], ["\n    margin-top: ", ";\n"])), function (props) { return props.theme.textOverlapLoader || !props.theme.text ? '0' : '10px'; });
var templateObject_1, templateObject_2;
